import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path clip-rule=\"evenodd\" d=\"M2.63 4.48a2 2 0 0 1 2-2h12.738a2 2 0 0 1 2 2v12.667a2 2 0 0 1-2 2H4.631a2 2 0 0 1-2-2V4.48z\" stroke=\"currentColor\"></path><g clip-path=\"url(#an73xooo2a)\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8.42 13.73h-.977a.978.978 0 0 1-.976-.972V8.87a.97.97 0 0 1 .976-.972H9m4.301 0h.977c.259 0 .507.102.69.285a.97.97 0 0 1 .286.687v3.89a.978.978 0 0 1-.976.972H12.72M17.207 11.3v-.973M11.35 7.897l-1.954 2.917h2.93l-1.953 2.916\"></path></g><defs><clipPath id=\"an73xooo2a\"><path fill=\"#fff\" transform=\"translate(5.979 4.98)\" d=\"M0 0h11.716v11.667H0z\"></path></clipPath></defs>", 3)
  ])))
}
export default { render: render }